// src/components/ScrollToTop.js
import React, { useState, useEffect } from 'react';
import { FaArrowCircleUp } from 'react-icons/fa';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    setVisible(scrolled > 300); // Show after scrolling 300px
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'instant' // Instant scroll to top,
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  return (
    <FaArrowCircleUp
      onClick={scrollToTop}
      style={{
        position: 'fixed',
        bottom: '40px',
        right: '40px',
        height: '40px',
        width: '40px',
        fontSize: '2rem',
        cursor: 'pointer',
        color: '#007bff',
        display: visible ? 'inline' : 'none',
        zIndex: 1000
      }}
      title="Go to top"
    />
  );
};

export default ScrollToTop;
